export default __webpack_public_path__ + "static/media/thalia.625fb4f6.jpg";